import {
	FileContainer,
	FileStatuses,
	FileWithPreview,
	formatForFileContainer,
	useFileContainers,
} from 'Modules'
import { FieldNames } from 'Constants/FieldNames'

export const useUploadHelpers = (fieldName: FieldNames) => {
	const { setFileContainersList, fileContainersMap } = useFileContainers()
	const fileContainersList = fileContainersMap.get(fieldName) || []

	const clearUploadList = () => {
		setFileContainersList({ fieldName, fileContainersList: [] })
	}

	const getFileList = fileContainersList?.length ? fileContainersList?.map(({ file }) => file) : []

	const setFiles = (files: FileWithPreview[]) => {
		setFileContainersList({
			fieldName,
			fileContainersList: formatForFileContainer(files),
		})
	}

	const changeStatusAndDescription = (
		fileName: string[],
		status?: FileStatuses,
		description?: string
	) => {
		setFileContainersList({
			fieldName,
			fileContainersList: fileContainersList?.map((fileContainer): FileContainer => {
				if (fileName.includes(fileContainer.file.name)) {
					return { ...fileContainer, description, status }
				}
				return fileContainer
			}),
		})
	}

	return {
		fileContainersList,
		clearUploadList,
		getFileList,
		setFiles,
		changeStatusAndDescription,
	}
}
